import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GnJsonTableComponent} from './json-table.component';
import {GnTableModule} from '../table/table.module';
import {GnTableButtonModule} from '../table-button/table-button.module';
import {GnCustomTableColumnDirective} from './custom-table-column.directive';
import {GnJsonFormModule} from '../json-form/json-form.module';
import {GnMessageServiceModule} from '../message-service/message-service.module';
import {GnEditColumnComponent} from './edit-column/edit-column.component';
import {GnEditColumnDirective} from './edit-column/edit-column.directive';


@NgModule({
  declarations: [
    GnJsonTableComponent,
    GnCustomTableColumnDirective,
    GnEditColumnComponent,
    GnEditColumnDirective
  ],
  exports: [
    GnJsonTableComponent,
    GnCustomTableColumnDirective,
    GnEditColumnComponent,
    GnEditColumnDirective
  ],
  imports: [
    CommonModule,
    GnTableModule,
    GnTableButtonModule,
    GnJsonFormModule,
    GnMessageServiceModule
  ]
})
export class GnJsonTableModule {
}
